import { createContext, useContext } from 'react'

/**
 * What the shell around a page offers it: a sidebar (so the header shows its toggle) and, in an org, the command
 * menu. The org app and the staff console have one; auth pages and Account don't (null).
 */
export type Shell = { openSearch?: () => void }

export const ShellContext = createContext<Shell | null>(null)

/** The shell around this page, or null outside one (the page's header then shows no sidebar toggle or search). */
export const useShell = (): Shell | null => useContext(ShellContext)
